<form class="{{className}}" [formGroup]="form" (submit)="handleSubmit($event)" (change)="handleChange($event)">
  <ng-container *ngFor="let field of config">
    <ng-container *ngIf="field.type">
      <div
        class="dynamic-form-field {{ rtl ? 'rtl' : '' }}"
        dir="{{ rtl ? 'rtl' : 'ltr' }}"
        *ngIf="!(resolveHidden(field.hidden) | async)"
        [ngClass]="field.containerClassNames"
      >
        <ng-container dynamicField [rtl]="rtl" [config]="field" [group]="form"> </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="field.push">
      <div class="break"></div>
    </ng-container>
  </ng-container>
</form>
